export const IconViber: {
  name: 'icon_viber-573f7e8b4e56'
} = {
  name: 'icon_viber-573f7e8b4e56'
}
